export default defineNuxtRouteMiddleware(async (to, from) => {
  if (!process.client) return; 

  const config = useRuntimeConfig();
  const userStore = useUserStore();

  console.log('masuk check-version middleware');

  const appVersion = config.public.app_version || '1.0.0';
  const currentVersion = localStorage.getItem('app_version') || '0.0.0';

  if (appVersion !== currentVersion) {
    await userStore.logout();
    console.log('App version has changed, logging out user');
    localStorage.setItem('app_version', String(appVersion));

    navigateTo('/')
  }
});
